// extracted by mini-css-extract-plugin
module.exports = {"open-in-new-tab":"open-in-new-tab__uGPgN"};